import Phaser from 'phaser';
import { GAME_WIDTH, GAME_HEIGHT, COLORS } from '../config/constants';
import { Sfx } from '../systems/Sfx';
import { Music } from '../systems/Music';

export class MainMenuScene extends Phaser.Scene {
  constructor() {
    super('MainMenu');
  }

  create(): void {
    Music.play('menu');

    this.add.image(GAME_WIDTH / 2, GAME_HEIGHT / 2, 'bg_halloweentown');

    this.add.image(GAME_WIDTH / 2, GAME_HEIGHT / 2 - 260, 'mascot_promo').setScale(1.4);

    this.add
      .text(GAME_WIDTH / 2, GAME_HEIGHT / 2 - 140, 'Spooky Stockings', {
        fontFamily: 'Georgia, serif',
        fontSize: '64px',
        color: '#ffffff',
        stroke: '#2e2a38',
        strokeThickness: 8
      })
      .setOrigin(0.5);

    this.add
      .text(GAME_WIDTH / 2, GAME_HEIGHT / 2 - 70, 'Catch it. Sort it. Save the holidays.', {
        fontFamily: 'Arial',
        fontSize: '24px',
        color: '#f5f8ff'
      })
      .setOrigin(0.5);

    this.createButton(GAME_WIDTH / 2, GAME_HEIGHT / 2 + 40, 'Play', () => {
      this.scene.start('LevelSelect');
    });

    this.createSettingsButton();
  }

  private createSettingsButton(): void {
    const button = this.add
      .circle(GAME_WIDTH - 44, 44, 22, 0x000000, 0.35)
      .setStrokeStyle(2, 0xffffff, 0.6)
      .setInteractive({ useHandCursor: true });
    this.add.text(GAME_WIDTH - 44, 44, '⚙', { fontSize: '22px', color: '#ffffff' }).setOrigin(0.5);
    button.on('pointerdown', () => {
      Sfx.buttonTap();
      this.scene.pause();
      this.scene.launch('Settings', { returnTo: 'MainMenu' });
    });
  }

  private createButton(x: number, y: number, label: string, onClick: () => void): void {
    const button = this.add
      .rectangle(x, y, 240, 72, COLORS.fusionGold, 1)
      .setStrokeStyle(4, COLORS.outline)
      .setInteractive({ useHandCursor: true });

    const text = this.add
      .text(x, y, label, { fontFamily: 'Arial', fontSize: '28px', color: '#2e2a38', fontStyle: 'bold' })
      .setOrigin(0.5);

    button.on('pointerover', () => button.setScale(1.05));
    button.on('pointerout', () => button.setScale(1));
    button.on('pointerdown', () => {
      Sfx.buttonTap();
      onClick();
    });
    text.setDepth(1);
  }
}
